
<div *ngIf="selectedUser">
  <p-toast></p-toast>
  <div [formGroup]="userForm">
    <p>
      Username: 
    </p>
    <input formControlName="username">
    <div>
      <button (click)="modifyPassword()" *ngIf="!editPassword">Modify password</button>
      <button (click)="cancelModifyPassword()" *ngIf="editPassword">Cancel</button>
    </div>
    <div *ngIf="editPassword">
      <p>
        New password:
      </p>
      <div *ngIf="hidingPassword">
        <input type="password" formControlName="password">
        <p-button icon="pi pi-eye" (onClick)="showPassword()"></p-button>
      </div>
      <div *ngIf="!hidingPassword">
        <input type="text" formControlName="password" >
        <p-button icon="pi pi-eye-slash" (onClick)="hidePassword()"></p-button>
      </div>
    </div>
    <p>
      Email:
    </p>
    <span>
      <input formControlName="email">
    </span>

    <p>
      Slack ID:
    </p>
    <input formControlName="slackId">
    <p>
      Roles: 
    </p>
    <div formArrayName="roles" *ngFor="let role of roles; let i = index">
      {{role}}
      <p-checkbox [formControlName]="i" [binary]="true"></p-checkbox>
    </div>
    <div>
      This user receive notification about Vademecum/Picture upload for Bruges
      <p-checkbox formControlName="receiveVademecum" [binary]="true"></p-checkbox>
    </div>
    <div>
      This user receive notification Email about students starting soon (less than 2 weeks) who didn't send Vademecum yet.
      <p-checkbox formControlName="receiveMailForBookingsWithoutVademecum" [binary]="true"></p-checkbox>
    </div>
    <div>
      This user can see archived elements.
      <p-checkbox formControlName="canSeeArchivedQuotationTemplates" [binary]="true"></p-checkbox>
    </div>

    <button [disabled]="userForm.invalid" (click)="sendForm()">Submit</button>
  </div>
</div>